import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RegisterSectionSignIn1 from '../components/sign-in/RegisterSectionSignIn1';

const meta = {
  title: 'Ordio — Create Account',
  meta: [
    {
      name: 'description',
      content: 'Create your Ordio account to start organizing your files with AI-powered tools and secure cloud storage.',
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
  ],
  link: [
    {
      rel: 'stylesheet',
      href: 'css/tailwind/tailwind.min.css',
    },
    {
      rel: 'stylesheet',
      href: 'https://rsms.me/inter/inter.css',
    },
    {
      rel: 'stylesheet',
      href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css',
    },
  ],
  style: [
    {
      cssText: `
        body {
          background-color: #ffffff;
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
          margin: 0;
          padding: 0;
          min-height: 100vh;
        }
        .dark body {
          background-color: #111827;
          color: #ffffff;
        }
      `,
    },
  ],
  script: [
    {
      src: 'js/global-2274.js',
    },
    {
      src: 'js/main.js',
    },
  ],
};

export default function Register() {
  // Ensure proper body styling on component mount
  useEffect(() => {
    // Apply body classes for consistent styling
    document.body.className = 'antialiased bg-white dark:bg-gray-900 text-gray-900 dark:text-white font-body';
    
    // Ensure minimum height for full viewport
    document.body.style.minHeight = '100vh';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    
    // Set root element styling
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.className = 'min-h-screen bg-white dark:bg-gray-900';
    }
  }, []);

  // After registration succeeds in your component tree, consume pending invite
  // The actual form lives in RegisterSectionSignIn1; we attach a global listener for a simple integration.
  useEffect(() => {
    const handler = async () => {
      const token = localStorage.getItem('access_token');
      const pending = localStorage.getItem('pending_invite_token');
      if (!token || !pending) return;
      try {
        await fetch(`${window.location.origin.replace(window.location.origin, '')}${''}`); // noop to keep linter calm
      } catch (_) {}
      try {
        await fetch(require('../services/api').buildUrl('/family/invites/accept'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ token: pending })
        });
      } catch (_) {}
      try { localStorage.removeItem('pending_invite_token'); } catch (_) {}
    };
    window.addEventListener('ordio:auth:logged-in', handler);
    return () => window.removeEventListener('ordio:auth:logged-in', handler);
  }, []);

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <RegisterSectionSignIn1 />
      </div>
    </React.Fragment>
  );
}

